import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { LoanProduct } from '@finley-technologies/finley-types';

import { CreditAgreement } from '../common';

type LoanProductEntityProps = {
  loanProductEntity: LoanProduct.LoanProductWithLoanTapeType;
  config?: CreditAgreement.Config.LoanProductMechanics.Config;
};
export const LoanProductEntity = ({
  loanProductEntity,
  config,
}: LoanProductEntityProps) => {
  return (
    <>
      <Flex alignItems="center" mb="10px">
        <Text fontSize="20px" fontWeight="bold">
          Entity
        </Text>
      </Flex>
      <Box display="flex" mb="35px" width="100%">
        <Table borderWidth="1px">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Type</Th>
              {config && <Th>External Receivable ID</Th>}
              {loanProductEntity.loanTapeType === 'preassignedMasterLoanTape' &&
                config && (
                  <>
                    <Th>Signaled Assignment Field</Th>
                    <Th>Signaled Assignment Value</Th>
                  </>
                )}
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{loanProductEntity.name}</Td>
              <Td>
                {commonUtils.toSentenceCase(loanProductEntity.loanTapeType)}
              </Td>
              {config && <Td>{config.externalReceivableIdField || '-'}</Td>}
              {loanProductEntity.loanTapeType === 'preassignedMasterLoanTape' &&
                config && (
                  <>
                    <Td>
                      {
                        config.signaledExternalAssignment
                          ?.signaledExternalAssignmentField
                      }
                    </Td>
                    <Td>
                      {
                        config.signaledExternalAssignment
                          ?.signaledExternalAssignment
                      }
                    </Td>
                  </>
                )}
            </Tr>
          </Tbody>
        </Table>
      </Box>
    </>
  );
};
